import classNames from 'classnames'
import './styles.scss'
import { VIRTUAL_TOUR_EVENT } from '../../constant'
import Button from '../../../elements/button'
import arrayRightIcon from '../../../../assets/arrow-right.svg'
import { useTranslation } from 'react-i18next'
import { useVehicleContext } from '../../../../hooks/useVehicleContext'
import { data } from '../../../../data'

function AssistantCardInterior({ className = '' }) {
  const { vehicleType } = useVehicleContext()

  const { t } = useTranslation()
  const handleVirtualTourStart = () => {
    const event = new CustomEvent('assistant-overlay', {
      detail: { mode: VIRTUAL_TOUR_EVENT.START_INTERIOR },
    })
    document.body.dispatchEvent(event)
  }
  return (
    <div
      className={classNames({
        [className]: true,
        'virtual-tour-assistant-card': true,
      })}
      style={{ backgroundImage: `url(${data[vehicleType].virtualCardImage.interior})` }}
      tabindex="1"
    >
      <div className="virtual-tour-assistant-card__content">
        <h1 className={'virtual-tour-assistant-card__title'}>
          {t('virtual.tour.card.interior.title')}
        </h1>

        <Button
          className={'virtual-tour-assistant-card__btn'}
          secondary={true}
          onClick={handleVirtualTourStart}
          label={t('virtual.tour.card.interior.cta')}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              handleVirtualTourStart()
            }
          }}
        >
          {t('virtual.tour.card.interior.cta')} <img src={arrayRightIcon} />
        </Button>
      </div>
    </div>
  )
}

export default AssistantCardInterior
